import isElectron from 'is-electron';
import styled, { css } from 'styled-components';
import { ReactComponent as SideMenu } from '../../../assets/icons/stacked-lines.svg';
import { Link } from 'react-router-dom';
import { palette } from '../../../theme/colors';

export const SHeaderWrapper = styled.header`
  display: flex;
  justify-content: center;
  z-index: 10;
`;

export const SHeaderContent = styled.div`
  flex: 1;
  ${
    // in the web version, the header is narrowed to the "simulated mobile screen width" of the <main> element
    isElectron() ? '' : 'max-width: 26rem;'
  }

  ${
    /*
      matching the color of the layout's main component (only necessary
      on web since on desktop the entire layout component has uniform background)
     */
    props =>
      isElectron()
        ? ''
        : css`
            background-color: ${props.theme.palette.background.primary};
          `
  }
`;

export const SHeader = styled.div<{
  backgroundColor?: string | null;
  extra: boolean;
}>`
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : props.theme.palette.background.nav};
  color: ${palette.white};
  border-radius: 0 0 17px 17px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  gap: 0.5rem;

  margin: auto;
  padding: 2em;

  height: ${props => (props.extra ? '4.86rem' : '4.81rem')};

  svg {
    aspect-ratio: 1;
  }
`;

export const Logo = styled.img`
  height: inherit;
  padding: 0.5rem 0;
  object-fit: contain;
`;

export const SBalanceSpace = styled.div`
  aspect-ratio: 1;
  width: 2rem;
`;

export const SLink = styled(Link)`
  height: 2.5rem;
  min-width: 2rem;
  display: flex;
  align-items: center;
`;

export const SSideMenu = styled(SideMenu)`
  width: 2.25rem;
  height: 2.25rem;
`;

export const SDots = styled.img`
  cursor: pointer;
`;

export const SHeaderMessageWrapper = styled.div<{ pointer?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 2.5rem;
  cursor: ${props => (props.pointer ? 'pointer' : 'default')};
`;

export const HeaderMessageText = styled.h3`
  text-align: center;
`;

export const SSubMessageText = styled.p<{ type: 'default' | 'accent' }>`
  text-align: center;
  font-family: 'Roboto-Medium';
  color: ${props =>
    props.type === 'accent' ? props.theme.palette.text.accent : props.theme.palette.text.primary};
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  padding-top: 0.25rem;
  text-align: center;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
`;
